import * as PIXI from "pixi.js";
import Game from "../Game";
import YellowCursorCircle from "../entities/YellowCursorCircle";
import Logo from "../entities/Logo";


export default class Layers extends PIXI.Container {
  static instance: Layers;
  private Game = Game.getInstance();
  Bottom: BaseLayer;
  Middle: BaseLayer;
  Top: BaseLayer;
  Info: BaseLayer;
  UI: BaseLayer;
  VideoMode: BaseLayer;
  constructor() {
    super();
    if (!Layers.instance) {
      Layers.instance = this;
    }

    this.Bottom = new BaseLayer();
    this.Middle = new BaseLayer();
    this.Top = new BaseLayer();
    this.Info = new BaseLayer();
    this.UI = new BaseLayer();
    this.VideoMode = new BaseLayer();
    this.UI.interactive = true;

    this.checkVideoMode();
    this.addToStage();
  }
  private checkVideoMode() {
    const params = new URLSearchParams(window.location.search);
    const videoMode = params.get("videomode");
    if (videoMode) {
      new Logo();
      new YellowCursorCircle();
    }
  }
  private addToStage() {
    this.Game.stage.addChild(this);
  }

  static getInstance() {
    return Layers.instance
  }
}


class BaseLayer extends PIXI.Container {
  Layers = Layers.getInstance();
  constructor() {
    super();
    this.addToLayers();
  }
  private addToLayers = () => this.Layers.addChild(this);

}